const IShareInfoActionTypes = {
    setFilterOption: 'setFilterOption',
    setShareInfoSortOptions: 'setShareInfoSortOptions',
    getShareInfo: 'getShareInfo',
    getShareStoreList: 'getShareStoreList',
    resetShareInfo: 'resetShareInfo',
    resetShareStoreList: 'resetShareStoreList',
    setSelectedRowShareInfo: 'setSelectedRowShareInfo',
};
const IShareInfoListMutations = {
    SET_FILTER_OPTION: 'SET_FILTER_OPTION',
    SET_SHARE_INFO_SORT_OPTIONS: 'SET_SHARE_INFO_SORT_OPTIONS',
    GET_SHARE_INFO: 'GET_SHARE_INFO',
    RESET_SHARE_INFO: 'RESET_SHARE_INFO',
    GET_SHARE_STORE_LIST: 'GET_SHARE_STORE_LIST',
    RESET_SHARE_STORE_LIST: 'RESET_SHARE_STORE_LIST',
    SET_SELECTED_ROW_SHARE_INFO: 'SET_SELECTED_ROW_SHARE_INFO',
};
export { IShareInfoActionTypes, IShareInfoListMutations, };
